import { useState, useEffect } from "react";

export default function useMobile(breakpoint = 1024) {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);
    useEffect(() => {
        const h = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", h);
        return () => window.removeEventListener("resize", h);
    }, [breakpoint]);
    return isMobile;
}
